import { FunctionalComponent, h } from "@stencil/core";

interface LabelProps {
    error?: boolean;
    errorMsg?: string;
    label?: string;
    labelInfo?: string;
    required?: boolean;
    htmlFor?: string | null;
    labelClasses?: string | null;
    legend?: boolean;
}

export const Label: FunctionalComponent<LabelProps> = ({
    error = false,
    errorMsg = "",
    label = "",
    labelInfo = "",
    required = false,
    htmlFor = null,
    labelClasses = null,
    legend = false
}) => {
    const errorMessageClass = "ux-label__error-message";
    const labelInfoClass = "ux-label__info";
    const hasErrorMsg = error && errorMsg !== "";
    const hasLabelInfo = labelInfo !== "";
    const hasLabel = label !== "";
    const Tag = legend ? "legend" : "label";
    if (!(hasLabel || hasErrorMsg)) {
        return null;
    }
    return (
        <Tag
            htmlFor={htmlFor}
            class={{
                "ux-label": true,
                "ux-label--error": error && errorMsg === "",
                [labelClasses]: labelClasses !== null
            }}
        >
            {label}
            {required && <span> *</span>}
            {/* Click on slot content should not focus the input element */}
            <span onClick={(e) => e.preventDefault()}>
                <slot />
            </span>
            {hasLabelInfo && (
                <span
                    class={{
                        [labelInfoClass]: true
                    }}
                >
                    {labelInfo}
                </span>
            )}
            {hasErrorMsg && (
                <span
                    class={{
                        [errorMessageClass]: true,
                        [`${errorMessageClass}--error-only`]: label === "" && !required
                    }}
                >
                    {errorMsg}
                </span>
            )}
        </Tag>
    );
};
